/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PatientCaseDto } from '../models/patient-case-dto';
import { PatientDataFieldDto } from '../models/patient-data-field-dto';
import { PatientDto } from '../models/patient-dto';
import { patientGetCasInfo } from '../fn/patient/patient-get-cas-info';
import { PatientGetCasInfo$Params } from '../fn/patient/patient-get-cas-info';
import { patientGetPatientCase } from '../fn/patient/patient-get-patient-case';
import { PatientGetPatientCase$Params } from '../fn/patient/patient-get-patient-case';
import { patientGetPatientForRecId } from '../fn/patient/patient-get-patient-for-rec-id';
import { PatientGetPatientForRecId$Params } from '../fn/patient/patient-get-patient-for-rec-id';
import { patientReadFileData } from '../fn/patient/patient-read-file-data';
import { PatientReadFileData$Params } from '../fn/patient/patient-read-file-data';
import { patientSearchPatient } from '../fn/patient/patient-search-patient';
import { PatientSearchPatient$Params } from '../fn/patient/patient-search-patient';

@Injectable({ providedIn: 'root' })
export class PatientApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `patientGetCasInfo()` */
  static readonly PatientGetCasInfoPath = '/api/patient/case-info/{casId}';

  /**
   * Get patient cas info by case Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientGetCasInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetCasInfo$Response(params: PatientGetCasInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientDataFieldDto>>> {
    const obs = patientGetCasInfo(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get patient cas info by case Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientGetCasInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetCasInfo(params: PatientGetCasInfo$Params, context?: HttpContext): Observable<Array<PatientDataFieldDto>> {
    const resp = this.patientGetCasInfo$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PatientDataFieldDto>>): Array<PatientDataFieldDto> => r.body)
    );
  }

  /** Path part for operation `patientGetPatientCase()` */
  static readonly PatientGetPatientCasePath = '/api/patient/case/{casId}';

  /**
   * Get patient case.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientGetPatientCase()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetPatientCase$Response(params: PatientGetPatientCase$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientCaseDto>> {
    const obs = patientGetPatientCase(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get patient case.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientGetPatientCase$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetPatientCase(params: PatientGetPatientCase$Params, context?: HttpContext): Observable<PatientCaseDto> {
    const resp = this.patientGetPatientCase$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PatientCaseDto>): PatientCaseDto => r.body)
    );
  }

  /** Path part for operation `patientReadFileData()` */
  static readonly PatientReadFileDataPath = '/api/patient/read-file';

  /**
   * Send xdt file to ixserv to extract patient data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientReadFileData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientReadFileData$Response(params: PatientReadFileData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Array<PatientDataFieldDto>>>> {
    const obs = patientReadFileData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Send xdt file to ixserv to extract patient data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientReadFileData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientReadFileData(params: PatientReadFileData$Params, context?: HttpContext): Observable<Array<Array<PatientDataFieldDto>>> {
    const resp = this.patientReadFileData$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Array<PatientDataFieldDto>>>): Array<Array<PatientDataFieldDto>> => r.body)
    );
  }

  /** Path part for operation `patientSearchPatient()` */
  static readonly PatientSearchPatientPath = '/api/patient/search';

  /**
   * Search for patient cases
   * Licenses.Document required for practice dummy user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientSearchPatient()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientSearchPatient$Response(params: PatientSearchPatient$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientCaseDto>>> {
    const obs = patientSearchPatient(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search for patient cases
   * Licenses.Document required for practice dummy user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientSearchPatient$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientSearchPatient(params: PatientSearchPatient$Params, context?: HttpContext): Observable<Array<PatientCaseDto>> {
    const resp = this.patientSearchPatient$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PatientCaseDto>>): Array<PatientCaseDto> => r.body)
    );
  }

  /** Path part for operation `patientGetPatientForRecId()` */
  static readonly PatientGetPatientForRecIdPath = '/api/patient/by-record/{recId}';

  /**
   * Get patient by record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientGetPatientForRecId()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetPatientForRecId$Response(params: PatientGetPatientForRecId$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientDto>> {
    const obs = patientGetPatientForRecId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get patient by record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientGetPatientForRecId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientGetPatientForRecId(params: PatientGetPatientForRecId$Params, context?: HttpContext): Observable<PatientDto> {
    const resp = this.patientGetPatientForRecId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PatientDto>): PatientDto => r.body)
    );
  }

}
